import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetAccountListWithStoreTicket = (prefix = '') => {
	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [searchParams] = useSearchParams()
	const getParamName = (paramName) =>
		prefix ? `${prefix}_${paramName}` : paramName

	const page = searchParams.get(getParamName('page'))
	const search = searchParams.get(getParamName('search'))
	const qualification = searchParams.get(getParamName('qualification'))
	const sortBy = searchParams.get(getParamName('sortBy'))
	const sortDirection = searchParams.get(getParamName('sortDirection'))
	const [userRole] = useRoleCookie()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		let url = `/${rolePath}/store/ticket/holder/list?page=${page || 1}`

		if (search) url += `&search=${search}`
		if (qualification && qualification !== 'all')
			url += `&proGrade=${qualification}`
		if (sortBy) url += `&sortBy=${sortBy}`
		if (sortDirection) url += `&sortDirection=${sortDirection}`

		fetchRequest('GET', url)
	}, [page, search, qualification, sortBy, sortDirection])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호를 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'search')
					setAlert('검색어를 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetAccountListWithStoreTicket
